// hover event handling
// see: https://gist.github.com/gragland/a32d08580b7e0604ff02cb069826ca2f

import { useCallback, useRef, useState } from 'react'

export default function useHover() {
  const [value, setValue] = useState(false)
	
  const handleMouseOver = useCallback(() => setValue(true), [])
  const handleMouseOut = useCallback(() => setValue(false), [])

  const ref = useRef()

  const callbackRef = useCallback(
    node => {
      if (ref.current) {
        ref.current.removeEventListener("mouseover", handleMouseOver)
        ref.current.removeEventListener("mouseout", handleMouseOut)
      }

      ref.current = node

      if (ref.current) {
        ref.current.addEventListener("mouseover", handleMouseOver)
        ref.current.addEventListener("mouseout", handleMouseOut)
      }
    },
    [handleMouseOver, handleMouseOut]
  )

  return [callbackRef, value]
}
